export default __webpack_public_path__ + "static/engage-07a4f47aa611ee8baa048d316e6ef644.png";